import { Injectable } from '@angular/core';
import { BeneListService } from './beneList.service';

@Injectable()
export class AllocatorService {
  private static subTotal: number;

  constructor(private beneListService: BeneListService) {}

  getSubTotalPrimary() {
    let toReturn: number = 0;
    for (let i = 0; i < this.beneListService.getPrimaryBeneList().length; i++) {
      toReturn += this.beneListService.getPrimaryBeneList()[i].ratio;
    }
    if (toReturn > 99.999 && toReturn < 100) {
      toReturn = 100;
    }
    return toReturn;
  }
  getSubTotalContingent() {
    let toReturn: number = 0;
    for (let i = 0; i < this.beneListService.getContingentBeneList().length; i++) {
      toReturn += this.beneListService.getContingentBeneList()[i].ratio;
    }
    if (toReturn > 99.999 && toReturn < 100) {
      toReturn = 100;
    }
    return toReturn;
  }
}
